import 'highlight.js/styles/github.css';
import CodeRenderer from './CodeRenderer';
import TableRenderer from './TableRenderer';

const LinkRenderer = (props: any) => {
    // Add target and rel attributes
    return <a target="_blank" rel="noopener noreferrer" {...props} />;
};

const renderers = {
    table: TableRenderer,
    a: LinkRenderer,
    code: CodeRenderer,
};

export default renderers;
